import { MDXComponentMap } from "@components/MDXComponentMap";

export function useMDXComponents(components: any) {
  return {
    ...MDXComponentMap,
    ...components,
  };
}
